import { useState } from "react";
import { Link } from "react-router-dom";
import { Merge, Minimize2, FileText, X } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const QUICK_TOOLS = [
  { slug: "merge-pdf", icon: Merge, color: "#2563eb", en: "Merge", fr: "Fusionner" },
  { slug: "compress-pdf", icon: Minimize2, color: "#7c3aed", en: "Compress", fr: "Compresser" },
  { slug: "pdf-to-word", icon: FileText, color: "#16a34a", en: "To Word", fr: "Vers Word" },
];

export default function MobileStickyBar() {
  const [dismissed, setDismissed] = useState(false);
  const { lang } = useLanguage();

  if (dismissed) return null;

  const label = lang === "fr" ? "Outils rapides" : "Quick tools";

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 sm:hidden bg-white border-t border-slate-200 shadow-lg px-3 py-2"
      data-testid="mobile-sticky-bar"
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs text-slate-500 font-medium flex-shrink-0">{label}</span>
        <div className="flex gap-2 flex-1 justify-center">
          {QUICK_TOOLS.map((tool) => {
            const Icon = tool.icon;
            return (
              <Link
                key={tool.slug}
                to={`/${tool.slug}`}
                data-testid={`sticky-tool-${tool.slug}`}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 text-xs font-medium text-slate-700 hover:bg-slate-50 transition-colors"
              >
                <Icon className="w-3.5 h-3.5" style={{ color: tool.color }} />
                {lang === "fr" ? tool.fr : tool.en}
              </Link>
            );
          })}
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="p-1 rounded-lg hover:bg-slate-100 text-slate-400 flex-shrink-0"
          aria-label="Dismiss"
          data-testid="sticky-bar-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
